import React, { useState, useEffect, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from 'primereact/radiobutton';
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import { FileService } from "../../../service/FileService";
import { ExerciceService } from "../../../service/ExerciceService";
import { useParams } from "react-router-dom";
import { FieldBuilder } from "../fields/FieldBuilder";

import { useDispatch, useSelector } from "react-redux";
import { getUsagerInfo } from "../../../store/actions/usager";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { ClapService } from "../../../service/ClapService";
import { AgentService } from "../../../service/AgentService";
import { BudgetService } from "../../../service/BudgetService";
import {setFiche, setFullActionSociale} from "../../../store/actions/actionSociale";

export const FormulaireTitreCulture = () => {

  const actionSociale = useSelector((state) => state.actionSociale);

  const { mode } = useParams();
  const [usager, setUsager] = useState(false);
  const [adresse, setAdresse] = useState(false);
  const [commande, setCommande] = useState(true);
  const [editCommande, setEditCommande] = useState(true);
  const [policyOne, setPolicyOne] = useState(false);
  const [policyTwo, setPolicyTwo] = useState(false);
  const [step, setStep] = useState(0);
  const [activeIndex, setActiveIndex] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const [showDemandeError, setShowDemandeError] = useState(false);
  const [maCommande, setMaCommande] = useState(true);
  const [optionChose, setOptionChose] = useState(true);
  const [justificatifPresence, setJustificatifPresence] = useState(null);
  const [hideJustificatif, setHideJustficatif] = useState(false);
  const fileUploadRef = useRef(null);
  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [codeError, setCodeError] = useState(false);
  
  const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);
  const [editFormData, setEditFormData] = useState(null);
  const [currentActionSociale, setCurrentActionSociale] = useState({});

  const [formatCheque, setFormatCheque] = useState();
  const [montantCheque, setMontantCheque] = useState();
  const [valeurCommande, setValeurCommande] = useState();
  const [fraisEnvoi ,setFraisEnvoi] = useState()

  //let fraisEnvoi;
  let createMode = "create";
  let editMode = "edit";
  let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];
  

  const text =<div><p>Politique de protection des données à caractère personnel</p>
          <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
          <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
          <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
          <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
          <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
          <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>


  const basicDialogFooter = (
    <Button
      type="button"
      label="RETOUR ESPACE AGENT"
      onClick={(e) => logoutRemoveData(e)}
      className="btn_submit_modal"
    />
  );

  const chequeCultureService = new ChequeCultureService();
  const fileService = new FileService();
  const linkService = new LinkProviderService();
  const exerciceService = new ExerciceService();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const budgetService = new BudgetService();
  const dispatch = useDispatch();


  useEffect(() => {
    fetchData();
    initActiveIndex();
  }, []);

  const fetchData = async () => {
    chequeCultureService.getUsagerInfo().then(
      (res) => {
        loadFormData(res.data);
      },
      [usager]
   );
    exerciceService.getExerciceEnCours();
  };

  const loadFormData = (loggedUsager) => {
    setUsager(loggedUsager);
    setAdresse(loggedUsager.adresse);
    if (loggedUsager != null && loggedUsager != undefined) {
      getParamDeleg(loggedUsager.codeDelegation);
      getJustificatifRequis();
    }
  };

  const justificatifsCategories = [
    { "key": "106", "value": "Justificatif de présence en établissement" ,"description":"Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."}
  ];

  const editJustificatifMsg = 'Votre justificatif n’était pas conforme: joindre une copie de votre dernier bulletin de paie ou à défaut une attestation de travail délivrée par votre établissement.'

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif à joindre est manquant. Merci d’en télécharger un",
      life: 5000,
    });
  };

  const showErrorMimeType = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif sélectionné ne correspond pas à l’un des formats de fichier acceptés. Merci d’en sélectionner un compatible.",
      life: 5000,
    });
  };

  const showErrorBudget = () => {
      toast.current.show({
        severity: "error",
        summary: "Budget insuffisant",
        detail:
          "Votre demande ne peut plus être envoyée car le budget alloué à la prestation est épuisé",
        life: 3600000,
      });
    };

  useEffect(() => {
    setActiveIndex(prevState => [...prevState, step]);
  },[step]);

  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([step]);
    if(editMode === mode) setActiveIndex([0,1,2,3,4,5]);
  };

  const nextStep = (e, increment) => {
    e.target.disabled = true;
    e.target.classList.add("disabled");
    e.target.style.pointerEvents = "none";
    e.target.style.display = "none";
    setStep(step + increment);
  };

  const showInfo = (msg) => {
    toast.current.show({
      severity: "info",
      summary: "Succés",
      detail: msg + " envoyée avec succés. ",
      life: 5000,
    });
  };

  const getParamDeleg = async (codeDelegation) => {
    chequeCultureService
      .getParamChequeCulture(codeDelegation)
      .then((res) => {
        setFraisEnvoi(res.data[0].fraisAffranchissement);
        if (mode == editMode) {
          loadCommandeForm();
          fetchDataForEdition();
        }
        const getProp = (prop) => (obj) => obj[prop];
        const getMontant = getProp("montant");
        const montans = res.data.map(getMontant);
        console.log("montants::" + montans);
        setMaCommande(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ================ EDIT PART ================== // 

  const libelleEnum = { '3710': 'TITRE CULTURE'};

  const loadCommandeForm = () => {
    console.log("TU ES EN EDIT MODE");

    //la on recup des truc
    chequeCultureService
      .getEditDto()
      .then((res) => {
        console.log("res.data",res.data)
        setEditCommande(res.data);
        let object = {
          valeurCommande: (res.data.montantTotal - fraisEnvoi) * 2,
          partCgos: res.data.montantTotal - fraisEnvoi,
          frais: fraisEnvoi,
          total: res.data.montantTotal,
          noteRetourAgent: res.data.noteRetourAgent,

        };
        setCommande(object);
        console.log("Editable ==== Commande (", commande , ") === editCommande (",editCommande)
      })
      .catch((error) => {
        console.log(error);
      });

    //la on va voir pour recup d'autre truc 
    
  };

  useEffect(() => {
    console.log("Editable ==== Commande (", commande , ") === editCommande (",editCommande)
  },[editCommande,commande])



  const fetchDataForEdition = () => {
    const as = {
      cas: "",
      exercice: "",
      fiche: "",
      optJustificatif: "",
      iban: "",
      maxVal: 0,
      enfants: [],
      listActionsSociale: [],
    };

    chequeCultureService.getEditDto().then((form) => {
      setEditFormData(form.data);
      as.cas = form.data.codeActionSociale;
      as.exercice = form.data.exercice;

      
      dispatch(getUsagerInfo()).then((user) => {
          if (user != null && user != undefined) {
            const bareme = {
              casCode: as.cas,
              delegId: user.codeDelegation,
              exercie: as.exercice,
              siActif: 1,
            };

            actionSocialeService.getActionSocialeDematByCASAndDlg(as.cas, user.codeDelegation).then((asList) => {
                Object.values(asList.data).map((item) => {
                  as.listActionsSociale.push(item);
                  if (item.codeActionSociale === as.cas && item.exercice === as.exercice) {
                    setCurrentActionSociale(item);
                  }
                });
                if(mode == editMode && !currentActionSociale?.exercice ){
                   let defaultActionSocial={codeActionSociale: as.cas,codeLibelle: libelleEnum[as.cas],
                   dateDebut: as.exercice,dateFin: as.exercice,codeDelegation: user.codeDelegation ,exercice: as.exercice,defaultEditMode:true
                   }
                   as.listActionsSociale.push(defaultActionSocial);
                   setCurrentActionSociale(defaultActionSocial);
                }

                agentService.getFicheAgent(user.numCgos, as.exercice).then((fiche) => {
                    as.fiche = fiche.data;

                    clapService.getIbanMembre(user.numCgos).then((resIban) => {
                        as.iban = resIban.data.numIBan;

                      clapService.getBaremes(bareme).then((bar) => {
                          as.maxVal = getValeurParticipation(as.fiche.quotientFamilial, bar.data);

                        getOptJustificatif(as.fiche.numCgos, as.fiche.codeSituationAdministrative, as.fiche.codePosition).then((resOpt) => {
                            as.optJustificatif = resOpt.data;

                          agentService
                            .getAgentEnfants(as.fiche.numCgos, as.fiche.codeDelegation, as.cas, as.exercice)
                            .then((enfants) => {
                              let items = [];
                              enfants.data.forEach((e) => items.push(e));
                              as.enfants = items;
                              dispatch(setFullActionSociale(as));
                            });
                        });
                      });
                    });
                });
              });
          } else {
            window.location(
              linkService.getRetourEaLoginAgent()
            );
          }
        },
        (error) => {
          window.location(linkService.getRetourEaLoginAgent());
        }
        
      );
    });
  };


     useEffect(() => {
        if (editFormData) {
          getOther();
        }
      }, [editFormData]);

      const getOther = () => {
        try {
          if (typeof editFormData.formJson === 'string' && editFormData.formJson.trim() !== '') {
            const jsonObj = JSON.parse(editFormData.formJson);

            setFormatCheque(jsonObj.FORMULAIRE[0].VALEUR.split('/')[0])
            setMontantCheque(jsonObj.FORMULAIRE[2].VALEUR.split('/')[0])
          }
        } catch (error) {
          console.error("Erreur lors du parsing de formJson:", error);
        }
      };



  const getOptJustificatif = (
    numCgos,
    codeSituationAdministrative,
    codePosition
  ) => {
    return clapService.getJustificatifForClapNoticeInfo(
      numCgos,
      codeSituationAdministrative,
      codePosition
    );
  };

  const getValeurParticipation = (qf, tranches) => {
    let val = 0;
    tranches.forEach((el, i) => {
      if (val !== 0) return;

      if (i === tranches.length - 1) {
        if (Number(qf) >= Number(el.borne)) {
          val = tranches[i].valeur;
        }
      } else if (Number(qf) < Number(tranches[i + 1].borne)) {
        val = el.valeur;
      }
    });
    return val;
  };

   // constitution de la liste des justifs à uploader en cas ce complément d'info
   let libelleJustifToDisplay = [];
   let codeJustifToUploadList = [];
   let cloneJustifToUploadList = [];

   if (editFormData != null && editFormData.filesToUpload != null && editFormData.filesToUpload.length > 0) {
        Object.values(editFormData.filesToUpload).forEach(file => {
            if(!codeJustifToUploadList.includes(file.codeJustificatif)){
                codeJustifToUploadList.push(file.codeJustificatif);
            }
            cloneJustifToUploadList.push(file.codeJustificatif);
            libelleJustifToDisplay.push(file.libelleJustificatifMotifSpecifique);
        });
        //libelleJustifToDisplay.push(editFormData.noteRetourAgent);
    }
    console.log("editFormData",editFormData)
// ================== END ============== //




  const getJustificatifRequis = async () => {
    chequeCultureService
      .getJustificatifRequis()
      .then((res) => {
        setHideJustficatif(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCommandeChanged = (e) => {

    if (optionChose == 1) {
      setOptionChose(2)
    } else {
      setOptionChose(1)
    }


    let object;

    if(formatCheque === "DEMAT"){
      object = {
        valeurCommande: montantCheque,
        partCgos: montantCheque / 2,
        frais: 0,
        total: montantCheque / 2,
        motif: formatCheque,
        envoi: true,
      };
    }
    else{
      object = {
        valeurCommande: montantCheque,
        partCgos: montantCheque / 2,
        frais: fraisEnvoi,
        total: montantCheque / 2 + fraisEnvoi,
        motif: formatCheque,
        envoi: true,
      };
    }

    setCommande(object);
  };

  const handleAnnuler = () => {
    chequeCultureService.redirectEaLegacy();
  };

  const onPolicyOneChange = () => {
    setPolicyOne(!policyOne);
  };

  const onPolicyTwoChange = () => {
    setPolicyTwo(!policyTwo);
  };

  const logoutRemoveData = (e) => {
    chequeCultureService.logOut().then((res) => {
      console.log(res);
    });
    handleAnnuler();
  };


  const submitEditedDemande = () => {

    const demande = {
      demandeId: editFormData.demandeId,
  };

    let justificatifsPresenceList = [];

    if(actionSociale.optJustificatif && justificatifPresence && justificatifPresence.length > 0){
        Object.values(justificatifPresence).forEach(jus => {
          justificatifsPresenceList.push(jus.category[1]);
        });
    }


    const infosDemandeClapDto = {
      "codeActionSociale": "3710",
      "emailPersonnel": usager.email,
      "exercice": localStorage.getItem('exerciceEnCours'),
      "justificatifsPresence": justificatifsPresenceList,
      "libelleActionSociale": 'TITRE CULTURE',
      "nom": usager.nom,
      "nomNaissance": usager.nomNaissance,
      "numCgos": usager.numCgos,
      "positionStatutaire": usager.libellePositionStatutaire,
      "prenom": usager.prenom,
      "qf": usager.quotientFamilial,
      "situationAdministrative": usager.libelleSituationAdministrative,
      "etbLibelle": usager.libelleEtablissement,
      "formatTitre" : formatCheque.toString(),
      "valeurCommandee":commande.valeurCommande.toString(),
      "participationCgos":commande.partCgos.toString(),
      "fraisEnvoi":commande.frais.toString(),
      "totalPayer":commande.total.toString(),
    };

    let recordIds=editCommande.filesToUpload.map(file => file.recordId);

    if (justificatifPresence && justificatifPresence.length > 0) {
      setDisabled(true);
      fileService
        .uploadEditedFiles(justificatifPresence, recordIds, codeJustifToUploadList)
        .then((res) => {
          if (null != res.data && res.data != undefined) {
            fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
              showInfo("Justificatif");
              updateEditedDemande(demande);
            });
          } else {
            setShowFileUploadError(true);
          }
        })
        .catch((err) => {
          window.location =
            "/#/serviceIndisponible/" + err.response.data.errorId;
        });
    } else {
      showError();
    }
  };





  const submitFormDemande = async (e) => {
       e.preventDefault();
       console.log("Clicked");
       if(e.detail == 1){
                const jsonFormSchemaJustif = {
                  formulaire: [
                    {
                        "code": "TYPE_DOSSIER_CLD",
                        "valeur": commande.motif.toString()
                    },
                    {
                        "code": "TYPE_COMMANDE_CLD",
                        "valeur":  checkPourcentageCommande(commande.valeurCommande),
                    },
                    {
                        "code": "MONTANT_COMMANDE_CLD_NEA",
                        "valeur": commande.valeurCommande.toString()
                    },
                    {
                        "code": "MONTANT_PARTICIPATION_CLD_NEA",
                        "valeur": commande.partCgos.toString()
                    },
                    {
                      "code": "MONTANT_FRAIS_PORT_CLD_NEA",
                      "valeur": commande.frais.toString()
                    },
                    {
                      "code": "MONTANT_A_PAYER_CLD_NEA",
                      "valeur": commande.total.toString()
                    }
                  ]
                };

                const demande = {
                  etape: "1",
                  origine: "NEA",
                  exercice: localStorage.getItem('exerciceEnCours'),
                  codeClasseur: "3710",
                  demandeStatutReferentiel: { id: 1 },
                  demandeDetails: [],
                };

                const demandeDetail = {
                  demandeType: {
                    codeActionSocial: "3710",
                  },
                  formJson: JSON.stringify(jsonFormSchemaJustif).toUpperCase(),
                  montant: commande.total,
                  motif:commande.motif,
                  version: "1",
                };

                demande.demandeDetails.push(demandeDetail);

                let justificatifsPresenceList = [];

                if(actionSociale.optJustificatif && justificatifPresence && justificatifPresence.length > 0){
                    Object.values(justificatifPresence).forEach(jus => {
                      justificatifsPresenceList.push(jus.category[1]);
                    });
                }

                const infosDemandeClapDto = {
                  "codeActionSociale": "3710",
                  "emailPersonnel": usager.email,
                  "exercice": localStorage.getItem('exerciceEnCours'),
                  "justificatifsPresence": justificatifsPresenceList,
                  "libelleActionSociale": 'TITRE CULTURE',
                  "nom": usager.nom,
                  "nomNaissance": usager.nomNaissance,
                  "numCgos": usager.numCgos,
                  "positionStatutaire": usager.libellePositionStatutaire,
                  "prenom": usager.prenom,
                  "qf": usager.quotientFamilial,
                  "situationAdministrative": usager.libelleSituationAdministrative,
                  "etbLibelle": usager.libelleEtablissement,
                  "formatTitre" :commande.motif.toString(),
                  "valeurCommandee":commande.valeurCommande.toString(),
                  "participationCgos":commande.partCgos.toString(),
                  "fraisEnvoi":commande.frais.toString(),
                  "totalPayer":commande.total.toString(),
                };


            if (hideJustificatif) {
              if (justificatifPresence && justificatifPresence.length > 0) {
                setDisabled(true);
                fileService
                  .uploadMultiFile(justificatifPresence)
                  .then((res) => {
                    if (null != res.data && res.data != undefined) {
                      budgetService.isEnoughBudget(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                          if(response.data){
                              fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                                budgetService.isEnoughSeuil(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                                    if(!response.data){
                                        fileService.createPdfDepassementPlafond("Demande avec dépassement plafond").then((response) => {
                                        showInfo("Justificatif");
                                        saveDemande(demande);

                                    });
                                  }else {
                                    showInfo("Justificatif");
                                    saveDemande(demande);
                                  }
                              });

                              });
                            }else{
                              showErrorBudget();
                            }
                          });

                    }else{
                      setShowFileUploadError(true);
                    }
                  })
                  .catch((err) => {
                    window.location =
                      "/#/serviceIndisponible/" + err.response.data.errorId;
                  });
              } else {
                budgetService.isEnoughBudget(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                  if(response.data){
                      fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                        budgetService.isEnoughSeuil(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                          if(!response.data){
                              fileService.createPdfDepassementPlafond("Demande avec dépassement plafond").then((response) => {
                              showInfo("Justificatif");
                              saveDemande(demande);

                          });
                        }else {
                          showInfo("Justificatif");
                          saveDemande(demande);
                        }
                        });
                    });
                  }else{
                    showErrorBudget();
                  }

                });

                }
            } else {
                budgetService.isEnoughBudget(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                    if(response.data){
                      fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                        budgetService.isEnoughSeuil(usager.codeDelegation,localStorage.getItem('exerciceEnCours'),commande.partCgos).then((response) => {
                          if(!response.data){
                              fileService.createPdfDepassementPlafond("Demande avec dépassement plafond").then((response) => {
                              showInfo("Justificatif");
                              saveDemande(demande);

                          });
                        }else {
                          showInfo("Justificatif");
                          saveDemande(demande);
                        }
                      });
                    });
                  }else{
                    showErrorBudget();
                  }
              });

            }
       }
  }

  const saveDemande = (demande) => {
    chequeCultureService
      .submitDemandeForm(demande)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
        window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };

  const updateEditedDemande = (demande) => {
    chequeCultureService
      .submitUpdatedDemande(demande.demandeId)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
        window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };

  const newMontantCheque = (e,index) => {
    setOptionChose(index)
    setMontantCheque(e.value);
  }

  const newConst = (e) => {
    setFormatCheque(e.value)
  }

  const isEnoughSeuil = (codeDelegation,exercice,montant) => {
      return budgetService.isEnoughSeuil(codeDelegation, exercice, montant);
  }

  const checkPourcentageCommande=(valeur)=>{
        const CommandesArray = [];
         maCommande.forEach((com) => {
             CommandesArray.push(com.montant);
         });
       if (valeur == Math.max(...CommandesArray)) {
                      return 'COMMANDE_CHQ_CULTURE_3710_CENT_POURCENT';
                    } else {
                      return 'COMMANDE_CHQ_CULTURE_3710_CINQUANTE_POURCENT'
        }
  }

  useEffect(() => {
    console.log("test - Le format de chèque a été mis à jour :", formatCheque);
    console.log("test - Le montant is update:", montantCheque);
    onCommandeChanged();
  }, [formatCheque,montantCheque]);

  useEffect(() => {
    console.log("commande", commande);
    
  },[commande])

  return (
        <div className="formClap" style={{ marginTop: "1%" }}>
        <ChequeCultureLegacy />
        <Toast ref={toast} position="top-center" className="toast-position" />

        {true &&
        <div className="mx-auto">
            <div className="no_shadow_no_border card" style={{padding:0}}>
                
                <form
                    action=""
                    id="espaceAgent"
                    method="POST"
                    name="formVacances"
                    className="cld-form-padding"
                >

            <Accordion activeIndex={activeIndex} multiple onTabChange={(e) => setActiveIndex(e.index)}>
                <AccordionTab header="Mes informations personnelles" disabled={true}>

                <dl className="dl-horizontal">
                    <div className="form-block-wrapper">
                        <h4>Mes informations personnelles</h4>
                        <dt>Numéro C.G.O.S</dt>
                        <dd>{usager.numCgos}</dd>
                        <dt>Etablissement</dt>
                        <dd>{usager.libelleEtablissement}</dd>
                        <dt>Civilité</dt>
                        <dd>{usager.civilite}</dd>
                        <dt>Prénom</dt>
                        <dd>{usager.prenom}</dd>
                        <dt>Nom</dt>
                        <dd>{usager.nom}</dd>
                        <dt>Nom de naissance</dt>
                        <dd>{usager.nomNaissance}</dd>
                        <dt>EMAIL PERSONNEL</dt>
                        <dd>{usager.email}</dd>
                    </div>
                </dl>

                <dl className="dl-horizontal">
                    <div className="form-block-wrapper">
                        <h4>Mon adresse personnelle</h4>
                        <dt>Bâtiment, entrée, résidence</dt>
                        <dd>{adresse.adresse2}</dd>
                        <dt>Appart., escalier</dt>
                        <dd>{adresse.adresse1}</dd>
                        <dt>N° et voie</dt>
                        <dd>{adresse.adresse3}</dd>
                        <dt>Lieu-dit</dt>
                        <dd>{adresse.adresse4}</dd>
                        <dt>Code postal</dt>
                        <dd>{adresse.codePostal}</dd>
                        <dt>Ville</dt>
                        <dd>{adresse.ville}</dd>
                        <dt>Pays</dt>
                        <dd>{adresse.pays}</dd>



                    </div>
                </dl>

                <div className="alert alert-info">
                <p>
                    <b>
                    Si certaines informations ne sont pas correctes, vous pouvez demander une mise à jour depuis la rubrique{" "}
                    <a href={linkService.getRetourEaMembreFiche()} style={{color: 'rgb(70,77,78)' }}>
                        {" "}
                        Mes infos {">"} Données personnelles
                    </a>
                    <br/>
                    ou vous pouvez vous adressez à votre contact C.G.O.S.
                    </b>
                </p>
                </div>

                {createMode === mode &&
                <div className="next-button-wrapper">
                    <button type="button"
                            className={("next-button button-arrow")}
                            style={({})}
                            onClick={(e) => nextStep(e, 1)}>
                        Etape suivante
                    </button>
                </div>}
            </AccordionTab>   
            <AccordionTab header="Ma commande" disabled={true}>        
            <br />

            

            <input
                type="hidden"
                name="$DTO_RECHERCHE_AGENT$PMC_ID"
                id="PMC_ID"
                value=""
            />

                <>
                  
                    <b>Choix du format</b>
                    <div className="alert alert-success">
                      <fieldset> 
                      <legend style={{fontSize: '1em'}}>Sélectionner le format des Titres culture</legend>

                        <div className="flex flex-column gap-3"> 
                          
                          <div className="flex align-items-center">
                                <RadioButton 
                                  inputId="DEMAT" 
                                  name="FORMAT" 
                                  value="DEMAT" 
                                  onChange={(e) => newConst(e)}
                                  checked={formatCheque === 'DEMAT'}
                                  disabled={mode == editMode ? true : false}
                                 />
                                <label htmlFor="DEMAT" className="ml-2">
                                  <b> E-titres culture </b> - disponibles sous 1 à 2 semaines. Pas de frais d’envoi. Utilisation depuis la plateforme électronique Pluxee
                                </label>
                            </div>

                            <br/>

                            <div className="flex align-items-center">
                                <RadioButton 
                                  inputId="PAPIER" 
                                  name="FORMAT" 
                                  value="PAPIER" 
                                  onChange={(e) => newConst(e)} 
                                  checked={formatCheque === 'PAPIER'} 
                                  disabled={mode == editMode ? true : false}
                                />
                                <label htmlFor="PAPIER" className="ml-2">
                                  <b>Titres culture papier</b> - expédié sous 4 à 6 semaines
                                </label>
                            </div>
                            
                          </div>
                        </fieldset>
                    </div>
                    

                    <br/><br/> 
                    
                    


                    <b>Valeur de ma commande</b>
                    
                    
                    <div className="alert alert-success">
                    <fieldset>
                      <legend style={{fontSize: '1em'}}>Sélectionner la valeur de la commande</legend>
                      {Array.isArray(maCommande) && maCommande.map((param, index) => (
                        
                        <div key={index} className="flex flex-column gap-3">
                          <div className="flex align-items-center">
                            
                            <RadioButton 
                                inputId={`montant-${param.montant}`}
                                name="PMC_ID_RADIO"
                                value={`${param.montant}`}
                                onChange={(e) => newMontantCheque(e,index)} 
                                checked={montantCheque === param.montant}
                                disabled={mode == editMode ? true : false}
                            />
                            <label htmlFor={`montant-${param.montant}`} className="ml-2">
                              <b>{param.montant}€</b>
                              {maCommande.length === 1 && (
                                <i> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 seule commande par an.</i>
                              )}
                              {maCommande.length === 2 && (
                                <i>
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                  {Math.max(...maCommande.map((item) => parseFloat(item.montant))) === parseFloat(param.montant)
                                    ? "1 seule commande par an."
                                    : "2 commandes possibles par an. Attention, la deuxième commande peut ne pas être honorée si le budget disponible est atteint."}
                                </i>
                              )}
                            </label>

                          </div>
                          <br/>
                        </div>
                      ))}
                      </fieldset>
                    </div>
                  
                </>
            
              
              <>
                <div className="next-button-wrapper">
                    <button type="button"
                            className={(!formatCheque || !montantCheque)
                                ? "next-button button-arrow disabled"
                                : "next-button button-arrow"}
                            style={(!formatCheque || !montantCheque)
                                ? {pointerEvents: "none"}
                                : {}}
                            onClick={(e) => {
                              onCommandeChanged();
                              nextStep(e, !hideJustificatif ? 3 : 1);
                              
                            }}
                            disabled={(!formatCheque || !montantCheque)} >
                        Etape suivante
                    </button>
                </div>
                </>

            </AccordionTab>    

            {hideJustificatif && (
            
                <AccordionTab header="J’ajoute mon justificatif de présence" disabled={true}> 
                  <dl className="dl-horizontal" style={{display: 'initial'}}>
                    <div className="form-block-wrapper" style={{ border: editMode === mode && !retourJustificatifPresence ? '3px solid red' : '', display : editMode === mode && retourJustificatifPresence ? 'none' : '' }}>
                      {console.log("retourJustificatifPresence",retourJustificatifPresence , "libelleJustifToDisplay",libelleJustifToDisplay)}
                      {editMode === mode &&
                      
                        /* &&(libelleJustifToDisplay.length >= 1) &&*/
                        <div className="info-wrapper-2" style={{backgroundColor:'lightyellow', justifyContent:'left'}}>
                            <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif", borderBottom : "none !important"}}>
                                <h4>Observations du C.G.O.S sur les documents déjà transmis :</h4>

                                {Object.entries(libelleJustifToDisplay).map(([key,val]) =>(
                                    <li>{val}</li>
                                ))}

                                <br></br>

                                <h4>Autre commentaire ou document complémentaire à nous envoyer :</h4>
                                <p>{editCommande.noteRetourAgent}</p>

                                <br></br>
                                
                                <p><font color="#0E5B7C">
                                <h4><b>Merci de renvoyer dans ce formulaire, après correction, les documents indiqués ci-dessus</b> (même nombre et mêmes types).</h4>
                                </font></p>
                                
                            </span>
                        </div>
                      }

                      <div name="jutificatif_area">
                          <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategories, 10000000, false, mode === editMode ? editJustificatifMsg : null]} onValueChange={(e) => setJustificatifPresence(e)} />
                          <br />
                      </div>
                    
                    </div>
                  </dl>
                  <div className="next-button-wrapper">
                      <button type="button"
                              className={!(justificatifPresence && justificatifPresence.length > 0)
                                  ? "next-button button-arrow disabled"
                                  : "next-button button-arrow"}
                              style={!(justificatifPresence && justificatifPresence.length > 0)
                                  ? {pointerEvents: "none"}
                                  : {}}
                              onClick={(e) => nextStep(e, 2)}
                              disabled={!(justificatifPresence && justificatifPresence.length > 0)} >
                          Etape suivante
                      </button>
                  </div>
                
                </AccordionTab>  
              )}
            <br/>

                
            <AccordionTab header="Récapitulatif de la demande" disabled={true}>  
            
              <dl className="dl-horizontal">
                <div className="form-block-wrapper">
                  <div id="div2" style={{ display: "block" }}>
                    
                    <dt>Format des titres culture</dt>
                    <dd>
                        {typeof commande.motif !== "undefined" &&
                        formatCheque == "DEMAT" ? "e-titres culture" : "Titres culture papier"}
                    </dd>

                    <dt>Valeur commandée</dt>
                    <dd>
                        {typeof commande.valeurCommande !== "undefined" &&
                        commande.valeurCommande + " €"}
                    </dd>
                    
                    <dt>Participation C.G.O.S &nbsp; 50% </dt>
                    <dd>
                        {typeof commande.partCgos !== "undefined" &&
                        commande.partCgos.toLocaleString("fr-FR") + " €"}
                    </dd>
                    
                    <dt>Frais d'envoi</dt>
                    <dd>
                        {typeof commande.frais !== "undefined" &&
                        commande.frais.toLocaleString("fr-FR") + " €"}
                    </dd>
                    
                    <dt>TOTAL à payer</dt>
                    <dd>
                      {typeof commande.total !== "undefined" &&
                      ((commande.total.toLocaleString("fr-FR") + " €") )}
                    </dd>

                    {hideJustificatif &&
                      (<div>
                          <dt>J’ajoute mon justificatif de présence</dt>
                          <dd>
                              <ul>
                                  {justificatifPresence && justificatifPresence.length > 0 &&
                                  Object.entries(justificatifPresence).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                              </ul>
                          </dd>
                      </div>)
                    }

                  </div>
                </div>
              </dl>

            {createMode === mode &&
                <div className="next-button-wrapper">
                    <button type="button"
                            className="next-button button-arrow"
                            onClick={(e) => nextStep(e, 1)}
                            >
                        Etape suivante
                    </button>
                </div>

              }

            </AccordionTab>   
            <AccordionTab header="Signature et envoi" disabled={true}>  

            <br />

            <div>
                <label>
                <input
                    type="checkbox"
                    id="check1"
                    onChange={onPolicyOneChange}
                />{" "}
                Je déclare sur l’honneur l’exactitude des informations concernant ma situation professionnelle, familiale et financière 
                et je déclare être informé que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, 
                fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement.
                </label>
            </div>

            <div>
                <label>
                <input
                    type="checkbox"
                    id="check2"
                    onChange={onPolicyTwoChange}
                />{" "}
                J’ai lu et j’approuve  la politique de gestion des données à caractère personnel renseignées dans ce formulaire.
                </label>
            </div>
            <br />


            <div id="textarea" >
                <span>{text}</span>
                <br></br>
                <p>
                Pour en savoir plus, consultez la <a href='https://www.cgos.info/17/politique-protection-donnees' target='_blank'>page d'information sur la politique de protection des données du C.G.O.S.</a>
                </p>
            </div>


            <br />
            <div className="alert alert-info">
                Dès que le C.G.O.S aura validé votre demande, vous recevrez un
                Email vous invitant à régler votre participation par Carte
                bancaire directement depuis votre Espace agent. Ce réglement
                doit avoir lieu <strong>dans les 48 H </strong>
                suivant la réception de cet Email, faute de quoi votre demande
                sera annulée.
                <p></p>
            </div>
            <br />

            <div className="form-group">
                <div className="navButtons cld-submit-buttons">
                <button
                    className="btn invalide"
                    type="button"
                    style={{ backgroundColor: "#C9C9C9" }}
                    name="RETOUR_PRESTATION"
                    onClick={logoutRemoveData}
                >
                    ANNULER
                </button>
                
                {mode == createMode && (
                    <button
                    className="btn"
                    type="button"
                    onClick={submitFormDemande}
                    name="ENVOYER_MA_DEMANDE"
                    disabled={
                        disabled ||
                        !commande.envoi ||
                        !policyOne ||
                        !policyTwo ||
                        !usager.numCgos
                    }
                    >
                    Envoyer ma demande
                    </button>
                )}

                {mode == editMode && (
                    <button
                    disabled={
                        disabled ||
                        !policyOne ||
                        !policyTwo ||
                        !usager.numCgos
                    }
                    className="btn"
                    type="button"
                    name="ENVOYER_MA_DEMANDE"
                    onClick={submitEditedDemande}
                    >
                    Envoyer ma demande
                    </button>
                )}

                <br />
                </div>
            </div>


                </AccordionTab>
            </Accordion>



        <Dialog
            closable={false}
            header=""
            visible={displayBasic}
            modal
            footer={basicDialogFooter}
        >
            <center>
            <h2>
                Votre demande a bien été envoyée et sera étudiée dans les
                meilleurs délais. <br />{" "}
            </h2>
            <br />
            <h4>
                Vous pouvez suivre son avancement depuis votre Espace agent,{" "}
                <a href={linkService.getRetourEaMembreSuiviDemande()}>
                rubrique Mes suivis.
                </a>
            </h4>
            <br />
            </center>
        </Dialog>

        <Dialog closable={false} header="" visible={showDemandeError} modal>
            <center>
            <h2>
                Un problème est survenu lors de l'envoi de votre demande de
                prestation : <b>{codeError}</b>
                <br />
            </h2>
            <br />
            <h3>
                Pour renvoyer votre demande allez sur le formulaire de demande{" "}
            </h3>
            <br />
            <br />
            <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
            <br />
            <Button
                type="button"
                label="RÉAFFICHER LE FORMULAIRE"
                onClick={() => window.location.reload(false)}
                className="btn_submit_modal"
            />
            </center>
        </Dialog>

        <Dialog
            closable={false}
            header=""
            visible={showFileUploadError}
            modal
        >
            <center>
            <h2>
                Echec d'envoi de votre demande de prestation Chèques culture{" "}
                <br />
            </h2>
            <br />
            <h3>
                En raison d’un problème technique : <b>{codeError}</b> les
                documents joints à votre demandes n’ont pas pu être
                enregistrés.
            </h3>
            <br />
            <h3>
                Merci de nous renvoyer votre demande après vous être assuré
                que les documents joints à celle-ci sont conformes aux
                caractéristiques (taille, format) indiquées sur le formulaire.
            </h3>
            <br />
            <Button
                type="button"
                label="RÉAFFICHER LE FORMULAIRE"
                onClick={() => window.location.reload(false)}
                className="btn_submit_modal"
            />
            </center>
        </Dialog>
                </form>
            </div>
        </div>}
    </div>
  )
};
